<script setup>
import vBtnBecameActive from "@directives/btn-became-active.js";
defineProps(['pages', 'onMenuClick']);
</script>

<template>
	<div class="modal-header-tabs-wrapper">
		<div class="modal-header-tabs">
			<div v-for="page in pages" :class="{active: page.active}" v-btn-became-active="page" class="eagle-tab">
				<a v-lang="page.lang" :class="{active: page.active}" @click.prevent.stop="onMenuClick ? onMenuClick(page) : getProp('onMenuItemClick')(page)" href="#" class="eagle-tab-link">{{ page.title }}</a>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@use "@css/shared";

.modal-header-tabs{
	z-index: 1;
	-webkit-tap-highlight-color: rgba(0,0,0,0);
	display: flex;

	&-wrapper{
		position: relative;
		z-index: 1;
		height: 50px;
		width: 100%;
		html.revamped-ui &{
			padding: 0 15px;
		}
		overflow: hidden;
		overflow-x: scroll;
		&::-webkit-scrollbar{
			display: none;
		}
	}

	#account-modal &-wrapper,
	#account-modal-header-outer &-wrapper{
		height: 65px;
	}

	& div{
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		& a{
			position: relative;
			display: block;
			text-decoration: none !important;
			white-space: nowrap;
			padding: 10px 25px;
			font-weight: normal !important;
			font-family: unset !important;
			&:hover{
				color:#fff !important;
			}
		}
		&:after{
			display: block;
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 2px;
			background: #fff;
			opacity: 0;
			transition: opacity 0.2s ease-in-out;
		}
		&.active{
			&:after{
				opacity: 1;
			}
		}
	}
}
</style>